export const subActivityList = "SUBACTIVITY_LIST";
export const subActivityUniqueList = "SUBACTIVITY_UNIQUE_LIST";